import { InjectionToken } from '@angular/core';

export const AUTH_SERVICE = new InjectionToken<any>('singleSPA.auth_service');
export const REGISTRY_SERVICE = new InjectionToken<any>('singleSPA.registry_service');
export const ROUTING_SERVICE = new InjectionToken<any>('singleSPA.routing_service');
